var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoDataAllcounsels = function SvgNoDataAllcounsels(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "10.0-Telecounselling",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.2.1.0-Telecounsel-/-All-counsels----empty",
    transform: "translate(-809, -415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.Organisms/07.Card/04.Confirmation/Empty-state",
    transform: "translate(697, 415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(112, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F1F1F1",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    rx: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "01.Icon/01.Basic/Fill/24/calendar-clear",
    transform: "translate(25.4231, 25.4173)",
    fill: "#666666",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3660027,29.1663148 C22.0951693,29.1663148 20.3100131,28.7064274 17.636836,27.2129378 C14.3861849,25.3900211 11.871862,23.7070784 8.63878906,20.482469 C5.52160154,17.3672346 4.00467445,15.3503075 1.88162756,11.4870262 C-0.516809949,7.12504704 -0.10795578,4.83858869 0.349075472,3.86137514 C0.893346308,2.69340639 1.69673173,1.99483868 2.73514319,1.3014793 C3.32495448,0.915044079 3.94912121,0.583782409 4.59972653,0.311895959 C4.6648307,0.283901168 4.72537758,0.257208459 4.77941404,0.233119917 C5.10167966,0.0879376249 5.58996091,-0.131463418 6.2084505,0.102911583 C6.62121092,0.257859501 6.98970051,0.574916794 7.56652342,1.14457826 C8.74946614,2.31124493 10.3660026,4.90955223 10.9623568,6.18559391 C11.3627474,7.04561995 11.6277214,7.61332829 11.6283724,8.25004704 C11.6283724,8.99548975 11.2533724,9.57035955 10.7982943,10.1908023 C10.7130078,10.3073387 10.6283724,10.4186668 10.5463411,10.5267398 C10.0508984,11.1777814 9.94217448,11.3659325 10.0137891,11.70187 C10.1589714,12.3770002 11.2416537,14.3867658 13.0209505,16.1621565 C14.8002474,17.9375471 16.7520703,18.95187 17.4298047,19.0964013 C17.7800651,19.1712711 17.9721224,19.0579898 18.6439974,18.544969 C18.7403516,18.4714013 18.8393099,18.3952294 18.9428256,18.3190575 C19.636836,17.8027815 20.1850131,17.4375471 20.9128777,17.4375471 L20.9167839,17.4375471 C21.5502475,17.4375471 22.0925652,17.7122867 22.9910027,18.1654117 C24.1628777,18.7565575 26.83931,20.3522606 28.0131381,21.5365054 C28.5841017,22.1120263 28.902461,22.4792138 29.05806,22.8913232 C29.292435,23.5117659 29.0717319,23.998094 28.9278517,24.3236148 C28.9037631,24.3776513 28.8770704,24.4368961 28.8490756,24.5026513 C28.5750376,25.1520979 28.2418185,25.7749496 27.8536329,26.3633284 C27.1615756,27.3984846 26.4604037,28.1999169 25.2898308,28.7448388 C24.6887388,29.0291553 24.0309062,29.1731884 23.3660027,29.1663148 L23.3660027,29.1663148 Z",
    id: "Path"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoDataAllcounsels, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-data-allcounsels.d3c86208.svg";
export { ForwardRef as ReactComponent };